"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PubSubProvider = void 0;
exports.createPubSubContext = createPubSubContext;
exports.useSubscribe = exports.usePublish = exports.usePubSub = void 0;

var _react = _interopRequireWildcard(require("react"));

var _pubSub = require("./pub-sub");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const PubSubContext = /*#__PURE__*/(0, _react.createContext)(null);

const PubSubProvider = ({
  children
}) => {
  const pubsubRef = (0, _react.useRef)(new _pubSub.PubSub());
  const {
    publish,
    subscribe
  } = pubsubRef.current;
  return /*#__PURE__*/_react.default.createElement(PubSubContext.Provider, {
    value: {
      publish,
      subscribe
    }
  }, children);
};

exports.PubSubProvider = PubSubProvider;

const useSubscribe = (event, callback) => {
  const {
    subscribe
  } = usePubSub();
  (0, _react.useEffect)(() => subscribe(event, callback), []);
};

exports.useSubscribe = useSubscribe;

const usePublish = () => usePubSub().publish;

exports.usePublish = usePublish;

const usePubSub = () => (0, _react.useContext)(PubSubContext);
/**
 * All return values are equal to their singleton versions but are typed.
 */


exports.usePubSub = usePubSub;

function createPubSubContext() {
  return {
    PubSubProvider,
    usePubSub: usePubSub,
    useSubscribe: useSubscribe,
    usePublish: usePublish
  };
}